import { api } from "../api";
import { PaginatedResponse, PaginationOptions } from "@/types/Pagination";

export const getTrackingTitlesForADog = async (dogId: string): Promise<object[]> => {    
    const { data } = await api.get<object[]>(`/AdminTitling/dogs/tracking`, { params: { dogId } });

    return data;
};

export const getRallyTitlesForADog = async (dogId: string): Promise<object[]> => {    
    const { data } = await api.get<object[]>(`/AdminTitling/dogs/rally`, { params: { dogId } });

    return data;
};

export const getObedienceTitlesForADog = async (dogId: string): Promise<object[]> => {    
    const { data } = await api.get<object[]>(`/AdminTitling/dogs/obedience`, { params: { dogId } });

    return data;
};

export const getAgilityTitlesForADog = async (dogId: string): Promise<object[]> => {    
    const { data } = await api.get<object[]>(`/AdminTitling/dogs/agility`, { params: { dogId } });

    return data;
};

export const getStockTitlesForADog = async (dogId: string): Promise<object[]> => {
    const { data } = await api.get<object[]>(`/AdminTitling/dogs/stock`, { params: { dogId } });

    return data;
};

export const getConformationTitlesForADog = async (dogId: string): Promise<object[]> => {
    const { data } = await api.get<object[]>(`/AdminTitling/dogs/conformation`, { params: { dogId } });

    return data;
};

export const getScentDetectionTitlesForADog = async (dogId: string): Promise<object[]> => {
    const { data } = await api.get<object[]>(`/AdminTitling/dogs/scentdetection`, { params: { dogId } });

    return data;
};

export const getDockJumpingTitlesForADog = async (dogId: string): Promise<object[]> => {
    const { data } = await api.get<object[]>(`/AdminTitling/dogs/dockjumping`, { params: { dogId } });

    return data;
};

export const getSourceCertificatesForADogSpecialty = async (dogId: string): Promise<object[]> => { 
    const { data } = await api.get<object[]>(`/AdminTitling/dogs/certificates/SP/source`, { params: { dogId } });

    return data;
};

export const getSourceCerticatesForAKennel = async (kennelId: string, program: string): Promise<object[]> => { 
    const { data } = await api.get<object[]>(`/AdminKennelTitling/certificates/${program}`, { params: { kennelId } });

    return data;
};

export const getCertificatesForADog = async (dogId: string, category: string): Promise<object[]> => { 
    const { data } = await api.get<object[]>(`/AdminTitling/dogs/certificates`, {
        params: { dogId, categories: category }
    });

    return data;
};

export const getShowResultsForADog = async (dogId: string, category: string): Promise<object[]> => { 
    const { data } = await api.get<object[]>(`/AdminTitling/showresults/dogs`, {
        params: { dogId, categories: category }
    });

    return data;
};
export const getDogsWithUnprocessedResults = async (program: string): Promise<object[]> => { 
    const { data } = await api.get<object[]>(`/AdminTitling/dogs/${program}`);

    return data;
};

export const processShowResults = async (program:string) : Promise<object[]> => {
    const { data } = await api.post<object[]>(`/AdminTitling/dogs/${program}`);

    return data;
}

export const getCertGenerationList = async (
    options: PaginationOptions,
    program?: string,
    executionId?: number,
) : Promise<PaginatedResponse<object>> => {
    const page = (options.page ?? 1) - 1;
    const pageSize = options.itemsPerPage ?? 25;
    const { data } = await api.get<PaginatedResponse<object>>(`/AdminTitling/certgeneration`, {
        params: { page, pageSize, program: program || undefined, executionId },
    });

    return data;
}
export const getCertGenerationDogsList = async (executionId: number) : Promise<object[]> => {
    const { data } = await api.get<object[]>(`/AdminTitling/certgeneration/${executionId}`);

    return data;
}

export const approveShowResults = async (executionId: number) : Promise<object[]> => {
    const { data } = await api.post<object[]>(`/AdminTitling/certgeneration/${executionId}/approve`);

    return data;
}

export const markCertGenerationPrinted = async (executionId: number) : Promise<object[]> => {
    const { data } = await api.post<object[]>(`/AdminTitling/certgeneration/${executionId}/print`);

    return data;
}

export const markUnprintedCertsPrinted = async (certType: string) : Promise<any> => {
    const { data } = await api.post<any>(`/AdminTitling/certgeneration/${certType}/markprinted`);

    return data;
}

export const getGeneratedNameForDog = async (dogId: string): Promise<object> => {
    const { data } = await api.get<object>(`/AdminTitling/dogs/generatedname`, { params: { dogId } });

    return data;
};

export const getNameForDog = async (dogId: string): Promise<object> => {
    const { data } = await api.get<object>(`/AdminTitling/dogs/name`, { params: { dogId } });

    return data;
};

export const getRanchTrialTitlesForADog = async (dogId: string): Promise<object[]> => {
    const { data } = await api.get<object[]>(`/AdminTitling/dogs/ranchtrial`, { params: { dogId } });

    return data;
};

export const getFarmTrialTitlesForADog = async (dogId: string): Promise<object[]> => {
    const { data } = await api.get<object[]>(`/AdminTitling/dogs/farmtrial`, { params: { dogId } });

    return data;
};

export const getSpecialtyTitlesForADog = async (dogId: string): Promise<object[]> => {
    const { data } = await api.get<object[]>(`/AdminTitling/dogs/specialty`, { params: { dogId } });

    return data;
};

export const transferUnusedPointsToACE = async (dogId: string, unusedPoints: any[], resultsSelectedForTransfer: any[]): Promise<any> => {
    var requestData = {
        dogId,
        unusedPoints,
        resultsSelectedForTransfer
    };

    const { data } = await api.post<any>(`/AdminTitling/agility/transferToACE`, requestData);

    return data;
};

export const untransferUnusedPointsFromACE = async (dogId: string): Promise<any> => {
    const { data } = await api.post<any>(`/AdminTitling/agility/untransferFromACE`, undefined, {
        params: { dogId }
    });

    return data;
};

export const updatePrefixSuffix = async (prefix: string, suffix: string, dogId: string): Promise<any> => {
    const { data } = await api.post<any>(`/Admin/dogs/updatePrefixSuffix`, { prefix, suffix, dogId });

    return data;
}

export const applyUtilityResultsToTitle = async (dogId: string, titlePath: string, resultsSelected: any[]): Promise<any> => {
    var requestData = {
        dogId,
        titlePath,
        resultsSelected
    };

    const { data } = await api.post<any>(`/AdminTitling/obedience/applyUtilityResultsToTitle`, requestData);

    return data;
};



export default {
    getTrackingTitlesForADog,
    getRallyTitlesForADog,
    getObedienceTitlesForADog,
    getAgilityTitlesForADog,
    getCertificatesForADog,
    getSourceCertificatesForADogSpecialty,
    getShowResultsForADog,
    getDogsWithUnprocessedResults,
    processShowResults,
    approveShowResults,
    markCertGenerationPrinted,
    getStockTitlesForADog,
    getConformationTitlesForADog,
    getCertGenerationList,
    getCertGenerationDogsList,
    getGeneratedNameForDog,
    getNameForDog,
    getFarmTrialTitlesForADog,
    getRanchTrialTitlesForADog,
    getSpecialtyTitlesForADog,
    transferUnusedPointsToACE,
    untransferUnusedPointsFromACE,
    markUnprintedCertsPrinted,
    applyUtilityResultsToTitle,
    getScentDetectionTitlesForADog,
    getDockJumpingTitlesForADog,
    getSourceCerticatesForAKennel,
};
